import { darkColors, lightColors } from '../../theme/colors'

export const light = {
  handleBackground: lightColors.backgroundAlt,
}

export const dark = {
  handleBackground: darkColors.backgroundAlt,
}
